export default class CredentialsHelper {

    static update(accessToken, refreshToken) {
        sessionStorage.setItem(ACCESS_TOKEN_ID, accessToken);
        sessionStorage.setItem(REFRESH_TOKEN_ID, refreshToken);
    }

    static clear() {
        sessionStorage.removeItem(ACCESS_TOKEN_ID);
        sessionStorage.removeItem(REFRESH_TOKEN_ID);
    }

    static get accessToken() {
        return sessionStorage.getItem(ACCESS_TOKEN_ID);
    }

    static get refreshToken() {
        return sessionStorage.getItem(REFRESH_TOKEN_ID);
    }

    static get isLoggedIn() {
        return !!CredentialsHelper.accessToken;
    }
}

const REFRESH_TOKEN_ID = 'refresh_token';
const ACCESS_TOKEN_ID = 'access_token';



// WEBPACK FOOTER //
// ./src/utils/credentials-helper.js